import React from 'react';
import {
  ModalContent,
  useColorModeValue,
} from '@chakra-ui/react';

/**
 * ModalContent con estilo plano alineado al admin.
 */
const AdminModalContent = ({ children, maxW, ...rest }) => {
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');

  return (
    <ModalContent
      maxW={maxW}
      borderRadius="md"
      borderWidth="1px"
      borderColor={borderColor}
      boxShadow="0 4px 24px rgba(0, 0, 0, 0.12)"
      {...rest}
    >
      {children}
    </ModalContent>
  );
};

export default AdminModalContent;
